import React, { Component } from "react";
import "../../../styles/components/legal/Legal.scss";
import ACP_ICON from "../../../styles/images/brands/acp.svg";

class TC extends Component {
  render() {
    return (
      <div className="acp-section">
        <meta httpEquiv="content-type" content="text/html; charset=utf-8" />
        <title />
        <meta name="generator" content="LibreOffice 6.4.7.2 (Linux)" />
        <meta name="author" content="support@go-evio.com" />
        <meta name="created" content="2023-02-14T14:39:00" />
        <style
          type="text/css"
          dangerouslySetInnerHTML={{
            __html:
              '\n      @page {\n        size: 21cm 29.7cm;\n        margin-left: 3cm;\n        margin-right: 3cm;\n        margin-top: 1.81cm;\n        margin-bottom: 1.25cm;\n      }\n      p {\n        margin-left: 0.83cm;\n        text-indent: -0.64cm;\n        margin-top: 0.23cm;\n        margin-bottom: 0cm;\n        direction: ltr;\n        text-align: left;\n        orphans: 0;\n        widows: 0;\n        background: transparent;\n      }\n      p.western {\n        font-family: "Arial", serif;\n        so-language: en-US;\n      }\n      p.cjk {\n        font-family: "Arial";\n      }\n      p.ctl {\n        font-family: "Vrinda";\n      }\n      a:link {\n        color: #0563c1;\n        text-decoration: underline;\n      }\n      a:visited {\n        color: #954f72;\n        text-decoration: underline;\n      }\n    ',
          }}
        />
        <div title="header">
          <p
            align="center"
            style={{
              marginLeft: "0cm",
              textIndent: "0cm",
              marginTop: "0cm",
              orphans: 2,
              widows: 2,
            }}
          >
            <br />
          </p>

          <p
            align="center"
            style={{
              marginTop: "0.21cm",
              marginBottom: "0cm",
              lineHeight: "0.6cm",
            }}
          >
            <img
              className="brand-img"
              src={ACP_ICON}
              name="Picture 1"
              align="bottom"
              height={200}
              border={0}
              alt="Acp"
            />
          </p>
        </div>
        <p
          className="western"
          align="center"
          style={{
            marginLeft: "0cm",
            textIndent: "0cm",
            marginTop: "0.21cm",
            lineHeight: "0.6cm",
            orphans: 2,
            widows: 2,
          }}
        >
          <font face="Lao Sangam MN, serif">
            <font face="Calibri, serif">
              <font size={3} style={{ fontSize: "12pt" }}>
                <b>
                  Termos e Condições de utilização da plataforma ACP ELECTRIC{" "}
                </b>
              </font>
            </font>
          </font>
        </p>
        <p
          className="western"
          style={{
            marginLeft: "0cm",
            textIndent: "0cm",
            marginTop: "0.21cm",
            lineHeight: "0.6cm",
            orphans: 2,
            widows: 2,
          }}
        >
          <br />
        </p>
        <p
          className="western"
          align="justify"
          style={{
            marginLeft: "0cm",
            textIndent: "0cm",
            marginTop: "0.21cm",
            lineHeight: "0.6cm",
            orphans: 2,
            widows: 2,
          }}
        >
          <a name="_Hlk124150307" />
          <font face="Lao Sangam MN, serif">
            <font face="Calibri, serif">
              <font size={3} style={{ fontSize: "12pt" }}>
                Os termos e condições seguintes (doravante referidos como
                “Termos e Condições”) regulam o acesso e a utilização da
                plataforma eletrónica de serviços de mobilidade elétrica ACP
                ELECTRIC, disponível na Play Store e na App Store (doravante,
                “plataforma ACP ELECTRIC”) para utilizadores individuais,
                empresariais ou outras entidades que se registem nesta
                plataforma (doravante conjuntamente definidos como o
                “Utilizador” ou os “Utilizadores”)
              </font>
            </font>
            <font color="#676767">
              <font face="Calibri, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  .
                </font>
              </font>
            </font>
          </font>
        </p>
        <ol>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A plataforma ACP ELECTRIC destina-se a utilizadores de
                    veículos elétricos, quer sejam sócios ACP quer não o sejam,
                    bem como a agentes económicos e entidades do setor público
                    ou social que pretendam usufruir e/ou promover os benefícios
                    associados à mobilidade elétrica.
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Sem prejuízo do disposto no número anterior, o Utilizador
                    que seja sócio ACP beneficiará de tarifas mais vantajosas
                    face aos restantes utilizadores da plataforma ACP ELECTRIC.
                    Para esse efeito, será necessária a validação, aquando da
                    utilização da App, da respetiva qualidade de sócio ACP.{" "}
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Ao aceder, instalar ou usar a plataforma ACP ELECTRIC, o
                    Utilizador manifesta a sua concordância, sem reservas, com
                    os presentes Termos e Condições, pelo que deve proceder à
                    leitura dos mesmos previamente a utilizar a plataforma ACP
                    ELECTRIC.{" "}
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Se não concordar com os presentes Termos e Condições, o
                    Utilizador não deve usar a plataforma ACP ELECTRIC nem
                    descarregar ou subscrever qualquer material ou serviço que
                    esta disponibilize.
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Os serviços são disponibilizados ao Utilizador conjuntamente
                    pelo ACP e pela EVIO - Electrical Mobility, S.A..
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    O Utilizador reconhece que os serviços prestados através da
                    plataforma ACP ELECTRIC se dirigem a pessoas singulares
                    maiores de 18 anos e/ou a pessoas coletivas. No caso de
                    pessoa singular, ao aceder à plataforma ACP ELECTRIC o
                    Utilizador declara ser maior de 18 anos. O Utilizador
                    reconhece e aceita que o acesso e utilização da plataforma
                    ACP ELECTRIC são da sua exclusiva responsabilidade,
                    comprometendo-se a utilizar a plataforma ACP ELECTRIC e os
                    respetivos serviços em conformidade com a lei vigente e de
                    acordo com os presentes Termos e Condições.
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Os presentes Termos e Condições poderão ser modificados e/ou
                    atualizados sempre que pertinente, mediante o respetivo
                    alerta prévio, com uma antecedência não inferior a quinze
                    dias, na plataforma ACP ELECTRIC, e envio de e-mail aos
                    Utilizadores registados, a fim de as alterações poderem ser
                    conhecidas pelos Utilizadores quando acedam à plataforma ACP
                    ELECTRIC e previamente a uma nova utilização desta, em
                    conformidade com o quadro legal aplicável aos contratos de
                    adesão. Após uma alteração dos Termos e Condições e
                    respetiva comunicação ao Utilizador, a utilização
                    subsequente da plataforma ACP ELECTRIC significa a
                    aceitação, por parte do Utilizador, dos Termos e Condições
                    modificados.{" "}
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <a name="_Hlk121366070" />
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    As diferentes componentes do tarifário e/ou a fórmula de
                    cálculo do valor em cada momento devido pelo Utilizador como
                    contrapartida pelos serviços da plataforma ACP ELECTRIC de
                    utilização de postos de carregamento são disponibilizadas ao
                    Utilizador imediatamente antes da realização da respetiva
                    operação utilizando, para o efeito, também informação
                    prestada por entidades terceiras, nomeadamente, entidades
                    gestoras de redes, operadores de postos de carregamento,
                    plataformas de roaming, reguladores e autoridades
                    tributárias.
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Os Termos e Condições estão disponíveis na plataforma ACP
                    ELECTRIC para consulta pelo Utilizador, salvo situações de
                    indisponibilidade de sistemas ou outro erro temporário que
                    impeça a disponibilização da informação.{" "}
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    O Utilizador deve manter uma cópia dos Termos e Condições
                    num ficheiro autónomo, no seu dispositivo ou em formato de
                    papel, para referência futura, sem prejuízo de os registos
                    digitais da plataforma ACP ELECTRIC associados à prestação
                    de cada serviço serem considerados suficientes para efeitos
                    de prova contratual.
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Os Termos e Condições regem-se e são interpretados de acordo
                    com a Lei Portuguesa, aceitando o Utilizador submeter-se à
                    jurisdição exclusiva dos tribunais portugueses para a
                    resolução de quaisquer litígios relacionados com os mesmos,
                    sem prejuízo do disposto em “Resolução de conflitos”.
                  </font>
                </font>
              </font>
            </p>
          </li>
        </ol>
        <p
          className="western"
          align="justify"
          style={{
            marginLeft: "0cm",
            textIndent: "0cm",
            marginTop: "0.21cm",
            lineHeight: "0.6cm",
            orphans: 2,
            widows: 2,
          }}
        >
          <font face="Lao Sangam MN, serif">
            <font face="Calibri, serif">
              <font size={3} style={{ fontSize: "12pt" }}>
                <b>Tratamento de dados pessoais</b>
              </font>
            </font>
          </font>
        </p>
        <ol start={12}>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    O Utilizador reconhece expressamente que, para que os
                    serviços descritos na plataforma ACP ELECTRIC possam ser
                    prestados, a EVIO e o ACP necessitam de recolher e tratar
                    certas informações do Utilizador, incluindo dados de
                    natureza pessoal.
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Para esse efeito, ao utilizar a plataforma ACP ELECTRIC, o
                    Utilizador consente no tratamento dos seus dados pessoais,
                    por parte do ACP e da EVIO, bem como na partilha dos
                    referidos dados entre o ACP e a EVIO, no âmbito e para
                    efeitos dos serviços prestados.
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Antes de utilizar e subscrever a plataforma ACP ELECTRIC, o
                    Utilizador deve consultar e aceitar a{" "}
                  </font>
                </font>
                <a href="https://legal.go-evio.com/pt/privacy">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <b>Política de Privacidade </b>
                    </font>
                  </font>
                </a>
                <font color="#0563c1">
                  <u>
                    <font face="Calibri, serif">
                      <font size={3} style={{ fontSize: "12pt" }}>
                        <b> da EVIO</b>
                      </font>
                    </font>
                  </u>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    {" "}
                    e a{" "}
                  </font>
                </font>
                <a href="https://www.acp.pt/politica-de-privacidade">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <b>Política de Privacidade do ACP</b>
                    </font>
                  </font>
                </a>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    , onde encontrará detalhadas as condições de recolha e
                    tratamento dos seus dados pessoais, os direitos que lhe
                    assistem, bem como outras informações relacionadas com o
                    tratamento de dados pessoais realizado pela EVIO e pelo ACP,
                    por subcontratantes e por entidades terceiras.
                  </font>
                </font>
              </font>
            </p>
          </li>
        </ol>
        <p
          className="western"
          align="justify"
          style={{
            marginLeft: "0cm",
            textIndent: "0cm",
            marginTop: "0.21cm",
            lineHeight: "0.6cm",
            orphans: 2,
            widows: 2,
          }}
        >
          <font face="Lao Sangam MN, serif">
            <font face="Calibri, serif">
              <font size={3} style={{ fontSize: "12pt" }}>
                <b>Serviços</b>
              </font>
            </font>
          </font>
        </p>
        <ol start={15}>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A plataforma{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    {" "}
                    ACP ELECTRIC
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    permite ao Utilizador beneficiar dos seguintes serviços e
                    funcionalidades:
                  </font>
                </font>
              </font>
            </p>
          </li>
        </ol>
        <ol type="a">
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font color="#000000">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      Serviços de mobilidade elétrica, que incluem a utilização
                      de postos de carregamento e o carregamento de veículos
                      elétricos em espaços onde existam postos de carregamento
                      conectados à rede EVIO;
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font color="#000000">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      Serviços de mobilidade elétrica, que incluem a utilização
                      de postos de carregamento e o carregamento de veículos
                      elétricos em postos de outras redes (roaming), a nível
                      nacional e internacional, que tenham acordo e integração
                      com a EVIO, sendo aplicável em Portugal o previsto no
                      Anexo I aos presentes Termos e Condições;
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font color="#000000">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      Gestão de postos de carregamento e dos respetivos
                      utilizadores;
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font color="#000000">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      Gestão de consumos de veículos elétricos e dos respetivos
                      utilizadores;
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font color="#000000">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      Acompanhamento do estado dos serviços;{" "}
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font color="#000000">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      Histórico de consumos e transações;
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font color="#000000">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      Estatísticas sobre os consumos;
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font color="#000000">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      Planeamento de rotas;
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font color="#000000">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      Comparação de custos entre postos de carregamento;
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font color="#000000">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      Localização de postos de carregamento e consulta da sua
                      disponibilidade;
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font color="#000000">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      Simulação de custo num posto de carregamento;
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font color="#000000">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      Suporte ao Utilizador, através de FAQ e menu
                      “Contacte-nos”.
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </li>
        </ol>
        <p
          className="western"
          align="justify"
          style={{
            marginLeft: "0cm",
            textIndent: "0cm",
            marginTop: "0.21cm",
            lineHeight: "0.6cm",
            orphans: 2,
            widows: 2,
          }}
        >
          <font face="Lao Sangam MN, serif">
            <font face="Calibri, serif">
              <font size={3} style={{ fontSize: "12pt" }}>
                <b>Acesso e condições de adesão</b>
              </font>
            </font>
          </font>
        </p>
        <ol start={16}>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A plataforma{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    está disponível, enquanto App, na Play Store e na App Store,
                    consoante o tipo de adesão do Utilizador. O acesso através
                    de smartphones pressupõe a utilização do sistema operativo
                    IOS (versão mínima suportada IOS 13.0) ou Android (versão
                    mínima suportada 6.0).
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A utilização da{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    plataforma
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    e o acesso aos respetivos serviços por pessoa singular
                    implica a efetivação de registo na App para telemóvel pelo
                    Utilizador.
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Ao registar-se na plataforma{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    , o Utilizador irá, para efeitos de autenticação, receber um
                    SMS, serviço fornecido pela Twilio.
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Com a utilização da plataforma{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    , o Utilizador assegura que todos os dados pessoais
                    introduzidos por si são verdadeiros, atuais e completos.
                    Qualquer ato do Utilizador que seja considerado como ilegal,
                    fraudulento ou enganador confere o direito de inibir o
                    acesso à plataforma{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    , podendo esta inibição resultar também de decisão judicial
                    ou ordem administrativa.
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    O acesso e utilização da{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    plataforma
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    pode ser feito em duas modalidades, consoante os serviços em
                    causa:{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <i>i)</i>
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    gratuito, limitado aos serviços disponíveis para esse
                    efeito, suportando o
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Utilizador apenas os custos dos serviços de
                    dados/telecomunicações e{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <i>ii)</i>
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    mediante{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    pagamento.
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Para que possa utilizar os serviços pagos, o Utilizador
                    deverá ter preenchido corretamente os seus dados fiscais{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    (NIF – Número de Identificação Fiscal, em caso de pessoa
                    singular, ou NIPC - Número de Identificação de Pessoa
                    Coletiva, em caso de pessoa coletiva){" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    e associado, pelo menos, um meio de pagamento válido na
                    plataforma
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    , i.e., um cartão de crédito que permita pagamentos online.
                  </font>
                </font>
              </font>
            </p>
          </li>
        </ol>
        <p
          className="western"
          align="justify"
          style={{
            marginLeft: "0cm",
            textIndent: "0cm",
            marginTop: "0.21cm",
            lineHeight: "0.6cm",
            orphans: 2,
            widows: 2,
          }}
        >
          <font face="Lao Sangam MN, serif">
            <font face="Calibri, serif">
              <font size={3} style={{ fontSize: "12pt" }}>
                <b>Faturação </b>
              </font>
            </font>
          </font>
        </p>
        <ol start={22}>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Será emitida uma fatura eletrónica correspondente às
                    utilizações dos serviços pagos. O Utilizador consente, desde
                    já, em receber exclusivamente fatura eletrónica, que será
                    enviada para o endereço de email indicado pelo Utilizador no
                    processo de registo.{" "}
                  </font>
                </font>
              </font>
            </p>
          </li>
        </ol>
        <p
          className="western"
          align="justify"
          style={{
            marginLeft: "0cm",
            textIndent: "0cm",
            marginTop: "0.21cm",
            lineHeight: "0.6cm",
            orphans: 2,
            widows: 2,
          }}
        >
          <font face="Lao Sangam MN, serif">
            <font face="Calibri, serif">
              <font size={3} style={{ fontSize: "12pt" }}>
                <b>Condições de utilização dos serviços, preços e tarifários</b>
              </font>
            </font>
          </font>
        </p>
        <ol start={23}>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Os serviços descritos no número 14 têm as seguintes
                    condições de utilização:
                  </font>
                </font>
              </font>
            </p>
          </li>
        </ol>
        <ul>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Alíneas a) a g) - são pagos.
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Alíneas h) a i) - são disponibilizados gratuitamente com
                    limites de utilização, podendo o Utilizador pagar para ter
                    acesso a limites superiores;{" "}
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Alíneas j) a l) – são gratuitos.{" "}
                  </font>
                </font>
              </font>
            </p>
          </li>
        </ul>
        <ol start={24}>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Relativamente aos serviços descritos nas alíneas a) e b) do
                    número 14:
                  </font>
                </font>
              </font>
            </p>
          </li>
        </ol>
        <ol>
          <ol type="i">
            <li>
              <p
                align="justify"
                style={{
                  textIndent: "0cm",
                  marginTop: "0.21cm",
                  lineHeight: "0.6cm",
                  orphans: 2,
                  widows: 2,
                }}
              >
                <font face="Lao Sangam MN, serif">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      A{" "}
                    </font>
                  </font>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      plataforma{" "}
                    </font>
                  </font>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      ACP ELECTRIC disponibiliza um serviço para Utilizadores de
                      veículos elétricos, que incorpora o uso de um local para
                      estacionamento e carregamento;
                    </font>
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{
                  textIndent: "0cm",
                  marginTop: "0.21cm",
                  lineHeight: "0.6cm",
                  orphans: 2,
                  widows: 2,
                }}
              >
                <font face="Lao Sangam MN, serif">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      A
                    </font>
                  </font>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      plataforma
                    </font>
                  </font>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      ACP ELECTRIC{" "}
                    </font>
                  </font>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      disponibiliza carregamentos{" "}
                    </font>
                  </font>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <i>ad hoc </i>
                    </font>
                  </font>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      em várias redes através de contratos instantâneos com o
                    </font>
                  </font>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <span style={{ letterSpacing: "-0.1pt" }}>
                        Utilizador
                      </span>
                    </font>
                  </font>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <span style={{ letterSpacing: "-0.2pt" }}>;</span>
                    </font>
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{
                  textIndent: "0cm",
                  marginTop: "0.21cm",
                  lineHeight: "0.6cm",
                  orphans: 2,
                  widows: 2,
                }}
              >
                <font face="Lao Sangam MN, serif">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      Ao aceder aos postos de carregamento, o Utilizador
                      obriga-se a respeitar todas as regras de utilização e
                      condições técnicas e de segurança aplicáveis e afixadas no
                      posto de carregamento em que o Utilizador se encontre;
                    </font>
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{
                  textIndent: "0cm",
                  marginTop: "0.21cm",
                  lineHeight: "0.6cm",
                  orphans: 2,
                  widows: 2,
                }}
              >
                <font face="Lao Sangam MN, serif">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      O serviço de mobilidade elétrica que inclui carregamento
                      inicia-se com a ativação do serviço pelo Utilizador
                      através da plataforma
                    </font>
                  </font>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      ACP ELECTRIC{" "}
                    </font>
                  </font>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      e termina com a respetiva desativação;
                    </font>
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{
                  textIndent: "0cm",
                  marginTop: "0.21cm",
                  lineHeight: "0.6cm",
                  orphans: 2,
                  widows: 2,
                }}
              >
                <font face="Lao Sangam MN, serif">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      Antes de iniciar o carregamento da sua viatura e para que
                      o serviço possa ser prestado, o Utilizador terá de
                      selecionar o posto de carregamento e tomada onde pretende
                      usufruir do serviço e efetuar a sua autenticação. A
                      autenticação pode ser realizada através de leitura de um
                      QR-Code (quando disponível) ou através de menu apropriado
                      na App ou de cartão físico (quando disponibilizado pela
                      EVIO). O valor a cobrar pelo serviço será medido através
                      do tempo de utilização do serviço e/ou dos kWh consumidos,
                      podendo acrescer uma componente de ativação dos serviços,
                      roaming e/ou de estacionamento após o término do
                      carregamento. Os valores fixados para utilização do
                      serviço dependem da qualidade do local de carregamento,
                      tempo de utilização do posto de carregamento, rede onde
                      estão ligados os postos de carregamento, potência do
                      local, pontos de interesse nos locais e outros serviços
                      disponíveis. O Utilizador deve consultar previamente na
                      plataforma ACP ELECTRIC o tarifário a cobrar para cada
                      ponto de carregamento. Em função das redes e dos locais,
                      pode haver lugar à incidência de tarifas praticadas por
                      terceiros, taxas e eventuais impostos;
                    </font>
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{
                  textIndent: "0cm",
                  marginTop: "0.21cm",
                  lineHeight: "0.6cm",
                  orphans: 2,
                  widows: 2,
                }}
              >
                <font face="Lao Sangam MN, serif">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      Os custos relacionados com o tempo máximo de utilização do
                      serviço ou de inatividade, bem como os custos de coimas ou
                      serviços de reboque decorrentes de estacionamento indevido
                      ou abusivo, serão imputados ao Utilizador, em conformidade
                      com o disposto na legislação e/ou regulamentação
                      aplicável;
                    </font>
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{
                  textIndent: "0cm",
                  marginTop: "0.21cm",
                  lineHeight: "0.6cm",
                  orphans: 2,
                  widows: 2,
                }}
              >
                <font face="Lao Sangam MN, serif">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      É eximida a responsabilidade por qualquer custo, dano,
                      prejuízo ou lucro cessante que possa resultar para o
                      Utilizador da indisponibilidade ou de mau funcionamento do
                      posto de carregamento selecionado através da plataforma{" "}
                    </font>
                  </font>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      ACP ELECTRIC. Verificando-se alguma destas situações, deve
                      ser contactada a entidade proprietária e/ou responsável
                      pela operação do posto de carregamento em causa
                    </font>
                  </font>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      .
                    </font>
                  </font>
                </font>
              </p>
            </li>
          </ol>
        </ol>
        <ol start={25}>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    No final da utilização de cada serviço de utilização de
                    posto de carregamento sujeito a pagamento, a plataforma{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    apresenta ao Utilizador o valor a cobrar pelo serviço
                    prestado, assim como o respetivo detalhe.
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Em caso de insucesso na cobrança do serviço, poderá ser
                    bloqueada a utilização de todos os serviços pelo Utilizador.
                    Para voltar a utilizar os serviços, o Utilizador deve
                    atualizar os seus meios de pagamento e pagar o valor em
                    dívida.
                  </font>
                </font>
              </font>
            </p>
          </li>
        </ol>
        <p
          align="justify"
          style={{
            marginLeft: "0.75cm",
            textIndent: "0cm",
            marginTop: "0.21cm",
            lineHeight: "0.6cm",
            orphans: 2,
            widows: 2,
          }}
        >
          <font face="Lao Sangam MN, serif">
            <font face="Calibri, serif">
              <font size={3} style={{ fontSize: "12pt" }}>
                <b>Operacionalidade da plataforma </b>
              </font>
            </font>
            <font face="Calibri, serif">
              <font size={3} style={{ fontSize: "12pt" }}>
                <b>ACP ELECTRIC</b>
              </font>
            </font>
          </font>
        </p>
        <ol start={27}>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Poderá interromper-se ou suspender-se temporariamente, e sem
                    aviso prévio, o acesso à plataforma{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    pelo período que seja determinado como necessário, por
                    quaisquer razões de ordem técnica, administrativa ou de
                    força maior. O Utilizador reconhece que as interrupções no
                    serviço podem ocorrer devido a situação de força maior,
                    nesta se incluindo tremores de terra, inundações, incêndios,
                    epidemias, sabotagens, greves, embargos ou bloqueios
                    internacionais, atos de guerra ou terrorismo, motins,
                    situações de emergência, contingência ou estado de alarme
                    provocado por uma epidemia ou pandemia. As interrupções ou a
                    redução do nível de serviço podem também resultar de falta
                    de capacidade de curto prazo devido a picos de utilização,
                    resultantes de um acesso em simultâneo de vários
                    Utilizadores à plataforma{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    , com o carregamento na potência máxima.
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A todo o tempo e sem necessidade de aviso prévio, poderá ser
                    alterada a apresentação e configuração da plataforma{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    .
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Serão realizados todos os esforços no sentido de manter a
                    operacionalidade e continuidade da plataforma{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    , evitar a presença de vírus ou outros elementos lesivos que
                    possam provocar alterações no sistema informático do
                    Utilizador, bem como fornecer informação exata e atualizada.
                    No entanto, e dada a interligação com diferentes entidades
                    que constituem fonte de informação da plataforma{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    , os conteúdos poderão não estar sempre atualizados, apesar
                    do esforço efetuado de forma regular para esse efeito, nem
                    se garante que a plataforma{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    funcione corretamente a todo
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    o momento, de forma rápida, ininterrupta e livre de erros.
                    Igualmente, não se garante a ausência de vírus ou elementos
                    lesivos que possam provocar alterações nos sistemas
                    informáticos dos Utilizadores, nos seus documentos
                    eletrónicos ou nos seus ficheiros.{" "}
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Em particular, e salvaguardadas situações de atuação dolosa
                    ou de negligência grosseira, em conformidade com a lei, não
                    haverá responsabilização pelos danos ou prejuízos
                    verificados na esfera do Utilizador que possam resultar de:
                  </font>
                </font>
              </font>
            </p>
          </li>
        </ol>
        <ol type="a">
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Dispositivos móveis utilizados pelo Utilizador;
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Impossibilidade ou dificuldades de utilização da plataforma{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    , incluindo, nomeadamente, atrasos, interrupções, avarias,
                    suspensão de comunicações, vírus, suspensão ou qualquer
                    outro impedimento dos servidores onde o sistema se encontra
                    alojado;
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Atrasos ou bloqueios no uso causados por deficiências ou
                    sobrecargas de Internet ou em outros sistemas eletrónicos;
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Possíveis erros ou deficiências de segurança que possam
                    ocorrer pelo uso, por parte do Utilizador, de equipamentos,
                    terminais ou browsers desatualizados ou inseguros;
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Falta de qualidade, atualidade, veracidade, licitude,
                    exatidão, completude, fiabilidade e/ou idoneidade de
                    conteúdos elaborados, produzidos, ou emitidos por terceiros,
                    assim como da existência de vícios ou defeitos de qualquer
                    tipo dos conteúdos transmitidos, difundidos, armazenados
                    e/ou colocados à disposição dos Utilizadores por tais
                    terceiros a que os Utilizadores acedam através da plataforma{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ou dos serviços oferecidos;
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              className="western"
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
                background: "#ffffff",
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Atuações de terceiros que violem direitos de propriedade
                    intelectual, segredos empresariais, direito à honra, à
                    intimidade pessoal e à própria imagem, assim como a
                    legislação em matéria de concorrência desleal e publicidade
                    ilícita;
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Acessibilidade, funcionamento ou disponibilidade de
                    conteúdos, informação e serviços oferecidos por terceiros
                    nos portais ligados à plataforma
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    , assim como da sua qualidade, licitude, fiabilidade e
                    utilidade. O Utilizador reconhece que a plataforma{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    pode estar hiperligada a outros sites e que não há, direta
                    ou indiretamente, qualquer aprovação, associação, ligação ou
                    relação com o site hiperligado, a não ser que esteja
                    especificamente estabelecido. Ao entrar na plataforma ACP
                    ELECTRIC, o Utilizador reconhece e aceita que não foram
                    revistos todos os sites hiperligados à plataforma ACP
                    ELECTRIC, pelo que é eximida a responsabilidade pelo
                    conteúdo de qualquer das páginas off-site ou qualquer site a
                    ele hiperligado. A ligação do Utilizador a quaisquer outras
                    páginas off-site ou outros sites corre por sua própria conta
                    e risco.
                  </font>
                </font>
              </font>
            </p>
          </li>
        </ol>
        <ol start={31}>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Os conteúdos disponibilizados por terceiros na plataforma{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    serão eliminados caso venha a concluir-se que são
                    manifestamente ilegais ou infringem direitos de terceiros,
                    ou no caso de tal ser ordenado por decisão judicial ou ordem
                    administrativa.
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A utilização e a qualidade da plataforma{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    , em especial quando acedida através de App, dependem do
                    dispositivo móvel utilizado para aceder à mesma, devendo o
                    Utilizador certificar-se de que o equipamento e o respetivo
                    sistema operativo utilizado suportam a App. Ao descarregar a
                    App, o Utilizador reconhece e aceita que o seu dispositivo
                    móvel permite o funcionamento daquela.
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A validação da qualidade de sócio ACP é efetuada
                    diariamente, podendo existir constrangimentos nessa
                    validação, até um prazo máximo de 24 (vinte e quatro) horas.
                    A efetivação da alteração da qualidade de sócio na App ACP
                    ELETRIC poderá ocorrer no prazo de até 3 (três) dias úteis.
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Cabe ao Utilizador manter e conservar o dispositivo móvel no
                    qual descarregue a App em condições de segurança e seguir as
                    práticas de segurança aconselhadas pelo fabricante e pela
                    operadora de telecomunicações, devendo instalar e manter
                    atualizados os necessários mecanismos de segurança,
                    nomeadamente um sistema antivírus.
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Qualquer falha no funcionamento da App decorrente da falta
                    de cumprimento do disposto nos números anteriores será da
                    exclusiva responsabilidade do Utilizador.
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A plataforma{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    (incluindo a respetiva App) é disponibilizada para uso
                    exclusivo do Utilizador, que se compromete a fazer uso da
                    mesma em conformidade com a lei vigente e com os presentes
                    Termos e Condições, obrigando-se, designadamente, a não a
                    utilizar para fins ilícitos, contrários ao estabelecido nos
                    presentes Termos e Condições, lesivos dos direitos e
                    interesses de terceiros ou que, de qualquer forma, possam
                    danificar, inutilizar, sobrecarregar ou deteriorar o
                    funcionamento normal da plataforma{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC. Em particular, é vedado realizar execuções
                    automatizadas/robotizadas na plataforma EVIO, utilizar a
                    plataforma EVIO com o objetivo de aumentar as necessidades
                    de processamento, de utilização de dados ou de armazenamento
                    da mesma e extrair da plataforma EVIO qualquer tipo de
                    informação para utilização com fins comerciais sem a
                    expressa autorização da EVIO
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    .
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Caso o Utilizador não cumpra o disposto nos n.
                  </font>
                </font>
                <sup>
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      os
                    </font>
                  </font>
                </sup>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    32, 34, e 36, poderá ser bloqueado o acesso do Utilizador à
                    App, bem como às respetivas funcionalidades.
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    O Utilizador deverá reportar quaisquer anomalias detetadas
                    relativamente ao uso da plataforma{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    , bem como quaisquer ações fraudulentas de terceiros.{" "}
                  </font>
                </font>
              </font>
            </p>
          </li>
        </ol>
        <p
          className="western"
          align="justify"
          style={{
            marginLeft: "0cm",
            textIndent: "0cm",
            marginTop: "0.21cm",
            lineHeight: "0.6cm",
            orphans: 2,
            widows: 2,
          }}
        >
          <font face="Lao Sangam MN, serif">
            <font face="Calibri, serif">
              <font size={3} style={{ fontSize: "12pt" }}>
                <b>Direitos de propriedade intelectual</b>
              </font>
            </font>
          </font>
        </p>
        <ol start={39}>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    O conteúdo e a estrutura da plataforma ACP ELECTRIC,
                    incluindo aplicações,{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <i>software</i>
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    , algoritmos, arquitetura, design,{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <i>look &amp; feel,</i>
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    bases de dados,{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <i>libraries</i>
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    , trabalhos derivados e desenvolvimentos futuros, é
                    protegido por direitos de propriedade intelectual da EVIO,
                    que abrangem direitos de autor e direitos conexos e direitos
                    de propriedade industrial, ao abrigo da legislação
                    portuguesa e europeia, incluindo, mas não limitando,
                    direitos{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <i>sui generis</i>
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    do autor de bases de dados, direitos sobre design, obras e
                    elementos publicitários, invenções (incluindo patentes e
                    modelos industriais), modelos e desenhos, sinais distintivos
                    de comércio (incluindo marcas, logótipos, recompensas, nomes
                    de estabelecimento e insígnias), firmas e nomes comerciais,
                    bem como segredos comerciais,{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <i>know-how</i>
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    e todos os outros direitos de caráter semelhante, incluindo
                    pedidos e aplicações para registo e independentemente de tal
                    registo ter sido efetuado ou de os direitos em questão não
                    estarem sujeitos a registo.
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    É vedado, em qualquer circunstância, adaptar, tentar
                    modificar ou alterar o código-fonte, efetuar operações de
                    engenharia reversa, criar obras derivadas do{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <i>software</i>
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    , descompilar ou desmontar, no todo ou em parte, qualquer
                    dos elementos que integram a plataforma ACP ELECTRIC, bem
                    como reproduzir, transferir, ceder, alugar, vender ou de
                    qualquer outro modo transmitir direitos de utilização da
                    plataforma ACP ELECTRIC, temporária ou permanentemente,
                    salvo autorização expressa da EVIO e do ACP, consoante
                    aplicável.{" "}
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Todas as tentativas de adulteração dos conteúdos ou da
                    estrutura da plataforma{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    e seus meios anexos, ou qualquer outra ação que possa causar
                    danos e pôr em risco a integridade do sistema, podem ser
                    objeto de processo judicial.
                  </font>
                </font>
              </font>
            </p>
          </li>
        </ol>
        <p
          className="western"
          align="justify"
          style={{
            marginLeft: "0cm",
            textIndent: "0cm",
            marginTop: "0.21cm",
            lineHeight: "0.6cm",
            orphans: 2,
            widows: 2,
            background: "#ffffff",
          }}
        >
          <font face="Lao Sangam MN, serif">
            <font face="Calibri, serif">
              <font size={3} style={{ fontSize: "12pt" }}>
                <b>Resolução e denúncia</b>
              </font>
            </font>
          </font>
        </p>
        <ol start={42}>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    O contrato de adesão aos presentes Termos e Condições poderá
                    ser resolvido quando ocorra uma violação dos mesmos.
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Os Termos e Condições cessam também quando qualquer das
                    Partes os denuncie, respetivamente, mediante comunicação
                    escrita com um pré-aviso de 15 dias e 30 dias.
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A verificação de qualquer das situações acima referidas
                    implica a cessação/impedimento de utilização da plataforma{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    pelo Utilizador.
                  </font>
                </font>
              </font>
            </p>
          </li>
        </ol>
        <p
          align="justify"
          style={{
            marginLeft: "0cm",
            textIndent: "0cm",
            marginTop: "0.21cm",
            lineHeight: "0.6cm",
            orphans: 2,
            widows: 2,
          }}
        >
          <font face="Lao Sangam MN, serif">
            <font face="Calibri, serif">
              <font size={3} style={{ fontSize: "12pt" }}>
                <b>Direito de livre resolução na prestação de serviços B2C</b>
              </font>
            </font>
          </font>
        </p>
        <ol start={45}>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Nos casos em que o Utilizador seja uma pessoa singular que
                    atue, no contexto dos presentes Termos e Condições, com fins
                    que não se integrem no âmbito da sua atividade comercial,
                    industrial, artesanal ou profissional (i.e., um consumidor)
                    e tenha subscrito serviços B2C com pagamento associado
                    através da plataforma{" "}
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    ACP ELECTRIC
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    , o mesmo tem o direito de, livremente, sem necessidade de
                    indicar o motivo, e sem haver lugar ao pagamento de uma
                    indemnização, resolver o contrato no prazo de 14 dias a
                    contar da data de subscrição dos serviços.{" "}
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    O disposto no número anterior não prejudica a obrigação de o
                    Utilizador efetuar o pagamento do montante correspondente
                    aos serviços prestados até ao momento da comunicação da
                    resolução, caso os mesmos se tenham iniciado no referido
                    período de 14 dias a contar da data de subscrição.
                  </font>
                </font>
              </font>
            </p>
          </li>
        </ol>
        <p
          className="western"
          align="justify"
          style={{
            marginLeft: "0cm",
            textIndent: "0cm",
            marginTop: "0.21cm",
            lineHeight: "0.6cm",
            orphans: 2,
            widows: 2,
          }}
        >
          <font face="Lao Sangam MN, serif">
            <font face="Calibri, serif">
              <font size={3} style={{ fontSize: "12pt" }}>
                <b>Comunicações</b>
              </font>
            </font>
          </font>
        </p>
        <ol start={47}>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Caso o ACP necessite de entrar em contacto com o Utilizador,
                    poderá utilizar os seguintes canais: carta, e-mail, SMS e
                    notificações
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <i>push</i>
                  </font>
                </font>
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <i>.</i>
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Mediante o consentimento prévio do utilizador, o ACP poderá
                    enviar comunicações relativas a:
                  </font>
                </font>
              </font>
            </p>
            <ol type="a">
              <li>
                <p
                  align="justify"
                  style={{
                    textIndent: "0cm",
                    marginTop: "0.21cm",
                    lineHeight: "0.6cm",
                    orphans: 2,
                    widows: 2,
                  }}
                >
                  <font face="Lao Sangam MN, serif">
                    <font face="Calibri, serif">
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Funcionalidades e serviços da plataforma ACP ELECTRIC;
                      </font>
                    </font>
                  </font>
                </p>
              </li>
              <li>
                <p
                  align="justify"
                  style={{
                    textIndent: "0cm",
                    marginTop: "0.21cm",
                    lineHeight: "0.6cm",
                    orphans: 2,
                    widows: 2,
                  }}
                >
                  <font face="Lao Sangam MN, serif">
                    <font face="Calibri, serif">
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Novos produtos e promoções do ACP;
                      </font>
                    </font>
                  </font>
                </p>
              </li>
              <li>
                <p
                  align="justify"
                  style={{
                    textIndent: "0cm",
                    marginTop: "0.21cm",
                    lineHeight: "0.6cm",
                    orphans: 2,
                    widows: 2,
                  }}
                >
                  <font face="Lao Sangam MN, serif">
                    <font face="Calibri, serif">
                      <font size={3} style={{ fontSize: "12pt" }}>
                        <i>Newsletters</i>
                      </font>
                    </font>
                    <font face="Calibri, serif">
                      <font size={3} style={{ fontSize: "12pt" }}>
                        e outras informações de{" "}
                      </font>
                    </font>
                    <font face="Calibri, serif">
                      <font size={3} style={{ fontSize: "12pt" }}>
                        <i>marketing</i>
                      </font>
                    </font>
                    <font face="Calibri, serif">
                      <font size={3} style={{ fontSize: "12pt" }}>
                        relativas à marca ACP e respetivas parcerias.
                      </font>
                    </font>
                  </font>
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    O Utilizador poderá contactar o ACP através dos seguintes
                    canais:
                  </font>
                </font>
              </font>
            </p>
            <ol type="a">
              <li>
                <p
                  align="justify"
                  style={{
                    textIndent: "0cm",
                    marginTop: "0.21cm",
                    lineHeight: "0.6cm",
                    orphans: 2,
                    widows: 2,
                  }}
                >
                  <font face="Lao Sangam MN, serif">
                    <font face="Calibri, serif">
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Atendimento telefónico comercial, através do número
                        215&nbsp;915&nbsp;915, disponibilizado na plataforma{" "}
                      </font>
                    </font>
                    <font face="Calibri, serif">
                      <font size={3} style={{ fontSize: "12pt" }}>
                        ACP ELECTRIC
                      </font>
                    </font>
                    <font face="Calibri, serif">
                      <font size={3} style={{ fontSize: "12pt" }}>
                        para o efeito, disponível das 8h às 22h nos dias úteis,
                        e nos dias não úteis, entre as 9h e as 22h.
                      </font>
                    </font>
                  </font>
                </p>
              </li>
              <li>
                <p
                  align="justify"
                  style={{
                    textIndent: "0cm",
                    marginTop: "0.21cm",
                    lineHeight: "0.6cm",
                    orphans: 2,
                    widows: 2,
                  }}
                >
                  <font face="Lao Sangam MN, serif">
                    <font face="Calibri, serif">
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Endereço de correio eletrónico: acpelectric
                      </font>
                    </font>
                    <font face="Calibri, serif">
                      <font size={3} style={{ fontSize: "12pt" }}>
                        @
                      </font>
                    </font>
                    <font face="Calibri, serif">
                      <font size={3} style={{ fontSize: "12pt" }}>
                        acp.pt;
                      </font>
                    </font>
                  </font>
                </p>
              </li>
              <li>
                <p
                  align="justify"
                  style={{
                    textIndent: "0cm",
                    marginTop: "0.21cm",
                    lineHeight: "0.6cm",
                    orphans: 2,
                    widows: 2,
                  }}
                >
                  <font face="Lao Sangam MN, serif">
                    <font face="Calibri, serif">
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Funcionalidade de suporte existente na plataforma ACP
                        ELECTRIC para telemóvel;
                      </font>
                    </font>
                  </font>
                </p>
              </li>
              <li>
                <p
                  align="justify"
                  style={{
                    textIndent: "0cm",
                    marginTop: "0.21cm",
                    lineHeight: "0.6cm",
                    orphans: 2,
                    widows: 2,
                  }}
                >
                  <font face="Lao Sangam MN, serif">
                    <font face="Calibri, serif">
                      <font size={3} style={{ fontSize: "12pt" }}>
                        Carta enviada para a morada Rua Rosa Araújo, n.º 24,
                        1250-195 Lisboa.
                      </font>
                    </font>
                  </font>
                </p>
              </li>
            </ol>
          </li>
        </ol>
        <p
          className="western"
          align="justify"
          style={{
            marginLeft: "0cm",
            textIndent: "0cm",
            marginTop: "0.21cm",
            lineHeight: "0.6cm",
            orphans: 2,
            widows: 2,
          }}
        >
          <font face="Lao Sangam MN, serif">
            <font face="Calibri, serif">
              <font size={3} style={{ fontSize: "12pt" }}>
                <b>Resolução de conflitos</b>
              </font>
            </font>
          </font>
        </p>
        <ol start={50}>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Em caso de existência de conflito, nomeadamente sobre a
                    interpretação, execução e aplicação das disposições legais
                    ou contratuais aplicáveis, as Partes procurarão resolvê-lo
                    amigavelmente.{" "}
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Sem prejuízo da possibilidade de recorrer aos tribunais
                    judiciais, o Utilizador de serviços B2C pode optar por
                    solicitar a intervenção de uma entidade de resolução
                    alternativa de litígios, nomeadamente através do recurso aos
                    mecanismos de arbitragem e mediação de conflitos previstos
                    no site da Direção-Geral do Consumidor em{" "}
                    <a href="https://www.consumidor.gov.pt/ral-mapa-e-lista-de-entidades.aspx">
                      https://www.consumidor.gov.pt/ral-mapa-e-lista-de-entidades.aspx
                    </a>{" "}
                    e a seguir indicados:
                  </font>
                </font>
              </font>
            </p>
          </li>
        </ol>
        <p
          align="justify"
          style={{
            marginLeft: "0.75cm",
            textIndent: "0cm",
            marginTop: "0.21cm",
            lineHeight: "0.6cm",
            orphans: 2,
            widows: 2,
          }}
        >
          <font face="Lao Sangam MN, serif">
            <font face="Calibri, serif">
              <font size={3} style={{ fontSize: "12pt" }}>
                CNIACC – Centro Nacional de Informação e Arbitragem de Conflitos
                de Consumo (www.arbitragemdeconsumo.org); CIMAAL – Centro de
                Informação, Mediação e Arbitragem de Conflitos de Consumo do
                Algarve (www.consumidoronline.pt); Centro de Arbitragem de
                Conflitos de Consumo do Distrito de Coimbra
                (www.centrodearbitragemdecoimbra.com); Centro de Arbitragem de
                Conflitos de Consumo de Lisboa (www.centroarbitragemlisboa.pt);
                Centro de Informação de Consumo e Arbitragem do Porto
                (www.cicap.pt); Centro de Arbitragem de Conflitos de Consumo do
                Vale do Ave (www.triave.pt); Centro de Informação, Mediação e
                Arbitragem de Consumo (
                <a href="http://www.ciab.pt/">www.ciab.pt</a>); Centro de
                Arbitragem de Conflitos de Consumo da Madeira
                (www.srrh.gov-madeira.pt) e Centro de Arbitragem da Universidade
                Autónoma de Lisboa (
                <a href="http://arbitragem.autonoma.pt/">
                  http://arbitragem.autonoma.pt
                </a>
                ).
              </font>
            </font>
          </font>
        </p>
        <p
          align="justify"
          style={{
            marginLeft: "0.75cm",
            textIndent: "0cm",
            marginTop: "0.21cm",
            lineHeight: "0.6cm",
            orphans: 2,
            widows: 2,
          }}
        >
          <br />
        </p>
        <p
          className="western"
          style={{
            marginLeft: "0cm",
            textIndent: "0cm",
            marginTop: "0cm",
            orphans: 2,
            widows: 2,
          }}
        >
          <br />
        </p>
        <p
          align="center"
          style={{
            marginLeft: "0cm",
            textIndent: "0cm",
            marginTop: "0.21cm",
            lineHeight: "0.6cm",
            orphans: 2,
            widows: 2,
            pageBreakBefore: "always",
          }}
        >
          <font face="Lao Sangam MN, serif">
            <font face="Calibri, serif">
              <b>Anexo I</b>
            </font>
          </font>
        </p>
        <p
          className="western"
          align="center"
          style={{
            marginLeft: "0cm",
            textIndent: "0cm",
            marginTop: "0.21cm",
            lineHeight: "0.6cm",
            orphans: 2,
            widows: 2,
          }}
        >
          <font face="Lao Sangam MN, serif">
            <font face="Calibri, serif">
              <font size={3} style={{ fontSize: "12pt" }}>
                <b>
                  Carregamento de veículos elétricos em postos integrados na
                  rede portuguesa MOBI.E
                </b>
              </font>
            </font>
          </font>
        </p>
        <p
          className="western"
          align="center"
          style={{
            marginLeft: "0cm",
            textIndent: "0cm",
            marginTop: "0.21cm",
            lineHeight: "0.6cm",
            orphans: 2,
            widows: 2,
          }}
        >
          <br />
        </p>
        <p
          className="western"
          align="justify"
          style={{
            marginLeft: "0cm",
            textIndent: "0cm",
            marginTop: "0.21cm",
            lineHeight: "0.6cm",
            orphans: 2,
            widows: 2,
          }}
        >
          <font face="Lao Sangam MN, serif">
            <font face="Calibri, serif">
              <font size={3} style={{ fontSize: "12pt" }}>
                A plataforma ACP ELECTRIC disponibiliza carregamentos
                <i> ad hoc </i> na rede MOBI.E através de contratos instantâneos
                entre a EVIO, na qualidade de comercializador de eletricidade
                para a mobilidade elétrica, titular do registo n.º 20, de 10 de
                julho de 2020{" "}
              </font>
            </font>
            <font face="Calibri, serif">
              <font size={3} style={{ fontSize: "12pt" }}>
                <span style={{ letterSpacing: "-0.1pt" }}>(“CEME”), </span>
              </font>
            </font>
            <font face="Calibri, serif">
              <font size={3} style={{ fontSize: "12pt" }}>
                <span style={{ letterSpacing: "-0.1pt" }}>
                  e o Utilizador, nas condições constantes dos números
                  seguintes:
                </span>
              </font>
            </font>
          </font>
        </p>
        <ol>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    Ao aceder aos postos de carregamento da rede MOBI.E, o
                    Utilizador obriga-se a cumprir as{" "}
                    <a href="https://www.mobie.pt/documents/42032/192209/Condi%C3%A7%C3%B5es+de+Utiliza%C3%A7%C3%A3o+da+Rede+de+Mobilidade+El%C3%A9trica_Fase+de+Mercado.pdf/21d83f9a-7936-fcf3-5dde-88dcf593f058?t=1634730974710">
                      {" "}
                      Condições de Utilização da Rede de Mobilidade Elétrica
                    </a>{" "}
                    (disponível em{" "}
                    <a href="https://www.mobie.pt/utilizar-a-rede">
                      https://www.mobie.pt/utilizar-a-rede
                    </a>
                    ) em cada momento vigentes e a respeitar todas as regras de
                    utilização e condições técnicas e de segurança aplicáveis e
                    afixadas no posto de carregamento em que o Utilizador se
                    encontre.
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    O preço de fornecimento devido pelo Utilizador por cada
                    carregamento de bateria de veículo elétrico é composto pelo
                    somatório das seguintes componentes:
                  </font>
                </font>
              </font>
            </p>
          </li>
        </ol>
        <ol type="a">
          <li>
            <p
              align="justify"
              style={{
                marginRight: "0.21cm",
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 0,
                widows: 0,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <span style={{ letterSpacing: "-0.3pt" }}>
                      Preço de energia, em função da quantidade total de
                      eletricidade em quilowatt hora (kWh) fornecida em cada
                      carregamento;
                    </span>
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                marginRight: "0.21cm",
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 0,
                widows: 0,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <span style={{ letterSpacing: "-0.3pt" }}>
                      Preço de utilização do ponto de carregamento, afixado no
                      local e que é cobrado pelo operador do ponto de
                      carregamento (“OPC”) à EVIO, na qualidade de CEME, que o
                      repercute no preço devido pelo utilizador;
                    </span>
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 0,
                widows: 0,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <span style={{ letterSpacing: "-0.3pt" }}>
                      Tarifas de ativação praticadas pelo CEME e OPC;
                    </span>
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                marginRight: "0.21cm",
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 0,
                widows: 0,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <span style={{ letterSpacing: "-0.3pt" }}>
                      Tarifas de acesso às redes de energia elétrica para a
                      mobilidade elétrica, fixadas pela Entidade Reguladora dos
                      Serviços Energéticos (“ERSE”), calculadas em função do
                      tipo de fornecimento (ponto de entrega da Rede Elétrica de
                      Serviço Público à rede da mobilidade elétrica em baixa
                      tensão ou média tensão) e período horário;
                    </span>
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                marginRight: "0.21cm",
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 0,
                widows: 0,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <span style={{ letterSpacing: "-0.3pt" }}>
                      IVA à taxa legal em vigor no momento da emissão da fatura,
                      Imposto Especial sobre o Consumo, bem como eventuais
                      outros impostos, taxas, encargos ou contribuições
                      legalmente aplicáveis ao fornecimento de eletricidade para
                      a mobilidade elétrica no momento da emissão da fatura;
                    </span>
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                marginRight: "0.21cm",
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 0,
                widows: 0,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <span style={{ letterSpacing: "-0.3pt" }}>
                      Apoios financeiros do Estado traduzidos em desconto a
                      aplicar ao custo de cada carregamento registado na rede de
                      mobilidade elétrica portuguesa.
                    </span>
                  </font>
                </font>
              </font>
            </p>
          </li>
        </ol>
        <ol start={3}>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <span style={{ letterSpacing: "-0.3pt" }}>
                      O Utilizador é informado e dá consentimento a um eventual
                      tratamento de dados pessoais (endereço de e-mail) pela
                      Entidade Gestora da Mobilidade Elétrica (“EGME”) para
                      efeitos de notificação da cessação do contrato de adesão à
                      rede de mobilidade elétrica relativamente ao CEME EVIO,
                      nos termos previstos no Regulamento da Mobilidade
                      Elétrica.
                    </span>
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <span style={{ letterSpacing: "-0.3pt" }}>
                      O Utilizador pode apresentar reclamação através de
                      qualquer um dos canais de atendimento referidos nas
                      alíneas b) e d) do número 49 dos Termos e Condições ou
                      através do livro de reclamação em formato eletrónico, cujo
                      acesso é disponibilizado através de página de internet.
                    </span>
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A EVIO obriga-se a responder a todas as reclamações que lhe
                    sejam dirigidas através de qualquer um dos canais de
                    atendimento acima indicados no prazo máximo de quinze dias
                    úteis após a data da sua receção.
                  </font>
                </font>
              </font>
            </p>
          </li>
          <li>
            <p
              align="justify"
              style={{
                textIndent: "0cm",
                marginTop: "0.21cm",
                lineHeight: "0.6cm",
                orphans: 2,
                widows: 2,
              }}
            >
              <font face="Lao Sangam MN, serif">
                <font face="Calibri, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    A EVIO não fica obrigada a suportar qualquer compensação ao
                    Cliente nas situações originadas por casos fortuitos ou de
                    força maior, no sentido dado pelo artigo 8.º do Regulamento
                    da Qualidade de Serviço, aprovado pelo Regulamento n.º
                    406/2021, de 12 de maio, da ERSE.
                  </font>
                </font>
              </font>
            </p>
          </li>
        </ol>
        <p
          className="western"
          align="justify"
          style={{
            marginLeft: "0cm",
            textIndent: "0cm",
            marginTop: "0.21cm",
            letterSpacing: "-0.3pt",
            lineHeight: "0.6cm",
            orphans: 2,
            widows: 2,
          }}
        >
          <br />
        </p>
        <p
          className="western"
          align="justify"
          style={{
            marginLeft: "0cm",
            textIndent: "0cm",
            marginTop: "0.21cm",
            lineHeight: "0.6cm",
            orphans: 2,
            widows: 2,
          }}
        >
          <br />
        </p>
      </div>
    );
  }
}

export default TC;
